import { memo } from "react";
import PropTypes from "prop-types";
import { resolutionPropType } from "app/utils/propTypes";
import VideoSwitchThumbnail from "app/pages/.shared/Video/VideoSwitchThumbnail";
import "./MediaArticleItem.scss";
import Separator from "app/pages/.shared/Separator";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import Paragraphs from "app/pages/.shared/Paragraphs";

const MEDIA_IMG_SIZES = {
	large: { width: 940, height: 460 },
	xlarge: { width: 940, height: 460 },
	medium: { width: 940, height: 460 },
	small: { width: 940, height: 460 },
};

const CLOUDINARY_OPTIONS = ["c_fill"];

const MediaArticleItem = ({
	title,
	descriptions = [],
	videoType,
	videoUrl,
	photoThumbnail,
	photoUrl,
	resolution,
	videoThumbnail,
	videoPreviewUrl,
	author,
}) => {
	return (
		<div className="media-article-item">
			<div className="media-article-item__article">
				<div className="media-article-item__title">{title}</div>
				<div className="media-article-item__media">
					{videoUrl ? (
						<VideoSwitchThumbnail
							sizes={MEDIA_IMG_SIZES}
							resolution={resolution}
							videoType={videoType}
							videoUrl={videoUrl}
							videoPreviewUrl={photoUrl ? photoUrl : videoPreviewUrl}
							videoThumbnail={photoThumbnail ? photoThumbnail : videoThumbnail}
						/>
					) : (
						<ProgressiveImg
							sizes={MEDIA_IMG_SIZES}
							resolution={resolution}
							thumbnail={photoThumbnail}
							src={photoUrl}
							cloudinaryOptions={CLOUDINARY_OPTIONS}
							offset={0}
							overflow // pour charger les images en lazyload dans une modal
						/>
					)}
				</div>
				<div className="media-article-item__description">
					<Paragraphs paragraphs={descriptions} enableHTMLFormatting />
				</div>
				{author && <div className="media-article-item__copyright">© {author}</div>}
				<Separator design="middle" />
			</div>
		</div>
	);
};

MediaArticleItem.propTypes = {
	videoThumbnail: PropTypes.string,
	videoPreviewUrl: PropTypes.string,
	title: PropTypes.string,
	resolution: resolutionPropType,
	descriptions: PropTypes.arrayOf(PropTypes.string),
	videoType: PropTypes.string,
	videoUrl: PropTypes.string,
	photoThumbnail: PropTypes.string,
	photoUrl: PropTypes.string,
	author: PropTypes.string,
};

export default memo(MediaArticleItem);
